import MonthTickFormatter from './component';

export default MonthTickFormatter;
